import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import { GcpProjectPicker } from './GcpProjectPicker';

export const GcpProjectPickerFieldExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'GcpProjectPicker',
    component: GcpProjectPicker,
  }),
);
